export enum SCREEN {
  IP_001 = "IP_001", // Trang chủ
  IP_002 = "IP_002", // Thông tin cá nhân
  IP_003 = "IP_003", // Kết quả thực hiện công việc
  IP_004 = "IP_004", // Khai báo nghỉ
  IP_005 = "IP_005", // Mẫu biểu nhân sự
  IP_006 = "IP_006", // Quy định
  IP_007 = "IP_007", // Văn hóa nội bộ
  IP_008 = "IP_008", // Bản tin
  IP_009 = "IP_009", // Chi tiết bản tin
  IP_010 = "IP_010", // Quá trinh công tác, hợp đồng
  IP_011 = "IP_011", // Báo cáo nghiên cứu
  IP_012 = "IP_012", // Văn bản nội bộ
  IP_014 = "IP_014", // Văn bản phân cấp ủy quyền
  IP_015 = "IP_015", // Chi tiết chấm công
  IP_016 = "IP_016", // Quản lý đơn
  IP_017 = "IP_017", // Quản lý đơn CBQL
  IP_018 = "IP_018", // Chấm công tháng
  IP_019 = "IP_019", // Quản lý chấm công CBQL
  IP_020 = "IP_020", // Sự kiên
  IP_021 = "IP_021", // Bảng công tháng nhân sự & hành chính
  IP_022 = "IP_022", // Button Chấm công Online
  IP_023 = "IP_023", // Quản lý đơn CBNV (HC)
  IP_024 = "IP_024", // Yêu cầu tuyển dụng
  IP_025 = "IP_025", // Đánh giá ứng viên // mock
  IP_026 = "IP_026", // Lịch phỏng vấn
  IP_027 = "IP_027", // Tra cứu thu nhập
  IP_028 = "IP_028", // Sinh nhật
}
